import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

console.log("[DEBUG] React mounting started");

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("[DEBUG] Root element (#root) not found in DOM");
  throw new Error("Root element not found");
}

console.log("[DEBUG] Creating React root");
const root = createRoot(rootElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
console.log("[DEBUG] React app mounted");
